import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FolderOpen, ChevronRight } from 'lucide-react';
import { useClientAuth } from '../../auth/ClientAuthContext';
import API_BASE from '../../utils/api';

export default function ClientDashboard() {
  const { clientAuth } = useClientAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!clientAuth?.token) return;

    fetch(`${API_BASE}/api/client/projects`, {
      credentials: 'include',
      headers: { Authorization: `Bearer ${clientAuth.token}` },
    })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setProjects)
      .catch(() => setError('Failed to load projects.'))
      .finally(() => setLoading(false));
  }, [clientAuth]);

  return (
    <div>
      <h1 className="cp-page-title">Your Projects</h1>
      <p className="cp-page-subtitle">
        Welcome back{clientAuth?.name ? `, ${clientAuth.name}` : ''}. Here are your active projects.
      </p>

      {loading && <p style={{ color: '#6b7280', fontSize: 14 }}>Loading…</p>}
      {error && <p className="cp-error">{error}</p>}

      {!loading && !error && projects.length === 0 && (
        <div className="cp-empty-state">
          <div className="cp-empty-state-icon"><FolderOpen size={36} /></div>
          <p style={{ margin: 0 }}>No projects have been shared with you yet.</p>
        </div>
      )}

      <div className="cp-project-grid">
        {projects.map((project, i) => (
          <Link
            key={project.projectId}
            to={`/client/projects/${project.projectId}`}
            className="cp-project-card"
            style={{ animationDelay: `${i * 0.05}s` }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p className="cp-project-name">{project.projectNickname || 'Untitled Project'}</p>
                {project.customerName && (
                  <p className="cp-project-meta">{project.customerName}</p>
                )}
                {project.address && (
                  <p className="cp-project-meta" style={{ marginTop: 2 }}>
                    {[project.address.street, project.address.city, project.address.state]
                      .filter(Boolean)
                      .join(', ')}
                  </p>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {project.status && (
                  <span className={`cp-badge ${statusClass(project.status)}`}>
                    {project.status}
                  </span>
                )}
                <ChevronRight size={16} color="#9ca3af" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

function statusClass(status) {
  const s = String(status).toLowerCase();
  if (s === 'active' || s === 'in progress') return 'cp-badge-green';
  if (s === 'completed') return 'cp-badge-blue';
  if (s === 'on hold') return 'cp-badge-yellow';
  return 'cp-badge-gray';
}
